"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _styles = require("@material-ui/styles");
var _FilterSortItem = _interopRequireDefault(require("./FilterSortItem"));
var _SearchInput = _interopRequireDefault(require("../../Input/SearchInput/SearchInput"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*:: import { type ThemeType } from '../../style/ThemeTypes';*/
var useStyles = (0, _styles.makeStyles)(function (theme /*: ThemeType*/) {
  var INPUT_PLACEHOLDER_VALUE = _objectSpread(_objectSpread({}, theme.mixins.inputPlaceholder), theme.typography.smallText);
  return {
    root: (0, _defineProperty2.default)({
      marginBottom: '.5rem'
    }, theme.breakpoints.gte.tablet.portrait, {
      marginBottom: 0
    }),
    input: {
      paddingTop: '.375rem',
      paddingBottom: '.375rem',
      borderColor: theme.colors.blueGrey,
      backgroundColor: theme.colors.blueGrey,
      '&:hover, &:focus': {
        borderColor: theme.colors.blueGrey,
        backgroundColor: theme.colors.blueGrey
      },
      '&::placeholder': INPUT_PLACEHOLDER_VALUE,
      '&::-webkit-input-placeholder': INPUT_PLACEHOLDER_VALUE,
      '&:-ms-input-placeholder': INPUT_PLACEHOLDER_VALUE,
      '&::-ms-input-placeholder': INPUT_PLACEHOLDER_VALUE,
      '&::-moz-placeholder': INPUT_PLACEHOLDER_VALUE,
      '&:-moz-placeholder': INPUT_PLACEHOLDER_VALUE
    }
  };
});
/*:: type Props = {
  onChange?: (event: SyntheticEvent<HTMLInputElement>) => any,
  defaultValue?: string,
  searchKey?: string
};*/
var FilterSortSearch = function FilterSortSearch(_ref /*:: */) {
  var defaultValue = _ref /*:: */.defaultValue,
    onChange = _ref /*:: */.onChange,
    searchKey = _ref /*:: */.searchKey;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_FilterSortItem.default, {
    label: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: "filter.search.label",
      defaultMessage: "Filter"
    })
  }, /*#__PURE__*/_react.default.createElement(_SearchInput.default, {
    "data-testid": "filter-sort-search",
    defaultValue: defaultValue,
    inputClassName: classes.input,
    key: searchKey,
    onChange: onChange
  })));
};
FilterSortSearch.displayName = 'FilterSortSearch';
var _default = exports.default = FilterSortSearch;
//# sourceMappingURL=FilterSortSearch.js.map